export const SIDEBAR_WIDTH = 300;
